import React from "react";
import styled from "styled-components";
import { FolderOpen } from "../assets/images/svg/FolderOpen";

type TotalCardType = {
  cardText: string;
  cardCount: number;
  color: string;
  bgcolor: string;
  active?: boolean;
};

const TotalCard = ({
  cardText,
  cardCount,
  color,
  bgcolor,
  active = false,
}: TotalCardType) => {
  return (
    <CardOuter bgcolor={bgcolor} color={color} active={active}>
      <FolderOpen color={color} />
      <div>
        <TotalType color={color}>{cardText}</TotalType>
        <TotalCount color={color}>{cardCount}</TotalCount>
      </div>
    </CardOuter>
  );
};

export default TotalCard;

type Props = {
  bgcolor: string;
  color: string;
  active: boolean;
};

const CardOuter = styled.div<Props>`
  display: flex;
  width: 16rem;
  background: ${(props) => props.bgcolor};
  border-radius: 0.5rem;
  align-items: center;
  gap: 0.5rem;
  padding: 1.75rem 0.75rem;
  // border-bottom: 6px solid
  //   ${(props) => (props.active ? props.color : "transparent")};
  @media only screen and (max-width: 768px) {
    padding: 1.25rem 1rem;
    width: auto;
  }
`;
const TotalType = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${(props) => props.color};
  padding-bottom: 0.5rem;
`;
const TotalCount = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1.625rem;
  line-height: 0.875rem;
  color: ${(props) => props.color};
`;
